import React from 'react';
import YoutubeEmbed from '../molecules/YoutubeEmbed';

/** Home Summer Camp section — click-to-load YouTube (WD-06). */
const YouTubeAutoplay = ({ videoId, title }) => (
  <YoutubeEmbed
    videoId={videoId}
    title={title}
    heading="Summer Camp 2025 Highlights"
    description="Experience the energy and excitement of our 2025 summer camp where students discovered the power of data through soccer."
  />
);

export default YouTubeAutoplay;
